export enum ProjectRevisionUpdateTypes {
  propertiesUpdated = 'PROPERTIES_UPDATED',
  noteAdded = 'NOTE_ADDED',
  noteUpdated = 'NOTE_UPDATED',
  noteDeleted = 'NOTE_DELETED',
  itemAdded = 'ITEM_ADDED',
  itemUpdated = 'ITEM_UPDATED',
  itemDeleted = 'ITEM_DELETED'
}
